var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.showClosePopUp) +
          " " +
          _vm._s(_vm.getConfirmBoxResponse) +
          "\n  "
      ),
      _vm.showlist
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "modal" } }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-mask upl-holdNEW wdth-700",
                    staticStyle: { "overflow-y": "auto", display: "block" },
                  },
                  [
                    _c("div", { staticClass: "modal-wrapper" }, [
                      _c("div", { staticClass: "modal-container" }, [
                        _c(
                          "div",
                          { staticClass: "modal-header" },
                          [
                            _vm._t("header", function () {
                              return [
                                _c("h4", { staticClass: "modal-title mt-2" }, [
                                  _vm._v(_vm._s(_vm.$t("ViewPackages"))),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "close up-close",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "Close",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.closePopUp("goBack")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  ×\n                "
                                    ),
                                  ]
                                ),
                              ]
                            }),
                          ],
                          2
                        ),
                        _c("div", { staticClass: "modal-body" }, [
                          _c("div", { staticClass: "view-packages-body" }, [
                            _c("div", { staticClass: "view-packages-button" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "secondary-btn ripple",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "modal",
                                    "data-target": "#expired",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showExpiredPackages()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("Expired")) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "primary-btn ripple",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "modal",
                                    "data-target": "#live",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showLivePackages()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("Live")) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "modal fade packages-popup packages-inner-popup",
                              attrs: {
                                id: "expired",
                                tabindex: "-1",
                                role: "dialog",
                                "aria-labelledby": "exampleModalCenterTitle",
                                "aria-hidden": "true",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "modal-dialog",
                                  attrs: { role: "document" },
                                },
                                [
                                  _c("div", { staticClass: "modal-content" }, [
                                    _c("div", { staticClass: "modal-header" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "close",
                                          attrs: {
                                            type: "button",
                                            "data-dismiss": "modal",
                                            "aria-label": "Close",
                                          },
                                          on: { click: _vm.closeselectedpack },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "modal-body" }, [
                                      _c(
                                        "div",
                                        { staticClass: "packages-table" },
                                        [
                                          _c("h2", [
                                            _vm._v("Expired packages"),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "table-responsive" },
                                            [
                                              _vm.inactive_packages.length > 0
                                                ? _c("div", [
                                                    _c(
                                                      "table",
                                                      { staticClass: "table" },
                                                      [
                                                        _c("thead", [
                                                          _c("tr", [
                                                            _c("th", [
                                                              _vm._v(
                                                                "Membership Number"
                                                              ),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v(
                                                                "Package Name"
                                                              ),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v("Amount"),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v(
                                                                "Currency"
                                                              ),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v(
                                                                "Expired Date"
                                                              ),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v("View"),
                                                            ]),
                                                          ]),
                                                        ]),
                                                        _c(
                                                          "tbody",
                                                          _vm._l(
                                                            _vm.inactive_packages,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c("tr", [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.Membership_number
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.Package_id
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "\n                                    " +
                                                                      _vm._s(
                                                                        _vm.twoDecimal(
                                                                          item.Package_purchase_value
                                                                        )
                                                                      ) +
                                                                      "\n                                  "
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.Currency
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "\n                                    " +
                                                                      _vm._s(
                                                                        new Date(
                                                                          item.Membership_number_expiry
                                                                        ).toLocaleString(
                                                                          "en-GB",
                                                                          {
                                                                            hour12: true,
                                                                            dateStyle:
                                                                              "short",
                                                                            timeStyle:
                                                                              "short",
                                                                          }
                                                                        )
                                                                      ) +
                                                                      "\n                                  "
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _c("a", {
                                                                    staticClass:
                                                                      "action-view",
                                                                    attrs: {
                                                                      href: "javascript:void(0);",
                                                                      "data-original-title":
                                                                        "View",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.getinactivepackservice(
                                                                            item
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                ]),
                                                              ])
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                  ])
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "no-content-added",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "col-md-12 text-center pt-4 d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "No expired packages found."
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm.showloader
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "processing_popup upload full-spinner",
                                            staticStyle: {
                                              visibility: "visible",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "spinner" },
                                              [
                                                _c("div", {
                                                  staticClass: "bounce1",
                                                }),
                                                _c("div", {
                                                  staticClass: "bounce2",
                                                }),
                                                _c("div", {
                                                  staticClass: "bounce3",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "modal fade packages-popup packages-inner-popup",
                              attrs: {
                                id: "live",
                                tabindex: "-1",
                                role: "dialog",
                                "aria-labelledby": "exampleModalCenterTitle",
                                "aria-hidden": "true",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "modal-dialog",
                                  attrs: { role: "document" },
                                },
                                [
                                  _c("div", { staticClass: "modal-content" }, [
                                    _c("div", { staticClass: "modal-header" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "close",
                                          attrs: {
                                            type: "button",
                                            "data-dismiss": "modal",
                                            "aria-label": "Close",
                                          },
                                          on: { click: _vm.closeselectedpack },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "modal-body" }, [
                                      _c(
                                        "div",
                                        { staticClass: "packages-table" },
                                        [
                                          _c("h2", [_vm._v("Live packages")]),
                                          _c(
                                            "div",
                                            { staticClass: "table-responsive" },
                                            [
                                              _vm.active_packages.length > 0
                                                ? _c("div", [
                                                    _c(
                                                      "table",
                                                      { staticClass: "table" },
                                                      [
                                                        _c("thead", [
                                                          _c("tr", [
                                                            _c("th", [
                                                              _vm._v(
                                                                "Membership Number"
                                                              ),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v(
                                                                "Package Name"
                                                              ),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v(
                                                                "Purchase Date"
                                                              ),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v("Amount"),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v(
                                                                "Currency"
                                                              ),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v("Select"),
                                                            ]),
                                                          ]),
                                                        ]),
                                                        _c(
                                                          "tbody",
                                                          _vm._l(
                                                            _vm.active_packages,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c("tr", [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.Membership_number
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.Package_id
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "\n                                    " +
                                                                      _vm._s(
                                                                        new Date(
                                                                          item.Package_creation_date
                                                                        ).toLocaleString(
                                                                          "en-GB",
                                                                          {
                                                                            hour12: true,
                                                                            dateStyle:
                                                                              "short",
                                                                            timeStyle:
                                                                              "short",
                                                                          }
                                                                        )
                                                                      ) +
                                                                      "\n                                  "
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "\n                                    " +
                                                                      _vm._s(
                                                                        _vm.twoDecimal(
                                                                          item.Package_purchase_value
                                                                        )
                                                                      ) +
                                                                      "\n                                  "
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.Currency
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.selectedpack,
                                                                          expression:
                                                                            "selectedpack",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "radio",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item,
                                                                      checked:
                                                                        _vm._q(
                                                                          _vm.selectedpack,
                                                                          item
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.selectedpack =
                                                                            item
                                                                        },
                                                                    },
                                                                  }),
                                                                ]),
                                                              ])
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                  ])
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "no-content-added",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "col-md-12 text-center pt-4 d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "No services found."
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                              _vm.selectedpack
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "primary-btn ripple pull-right",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click:
                                                          _vm.viewactiveservices,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            View\n                          "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm.showloader
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "processing_popup upload full-spinner",
                                        staticStyle: { visibility: "visible" },
                                      },
                                      [
                                        _c("div", { staticClass: "spinner" }, [
                                          _c("div", { staticClass: "bounce1" }),
                                          _c("div", { staticClass: "bounce2" }),
                                          _c("div", { staticClass: "bounce3" }),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "modal fade packages-popup packages-inner-popup",
                              attrs: {
                                id: "activeservices",
                                tabindex: "-1",
                                role: "dialog",
                                "aria-labelledby": "exampleModalCenterTitle",
                                "aria-hidden": "true",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "modal-dialog",
                                  attrs: { role: "document" },
                                },
                                [
                                  _c("div", { staticClass: "modal-content" }, [
                                    _c("div", { staticClass: "modal-header" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "close",
                                          attrs: {
                                            type: "button",
                                            "data-dismiss": "modal",
                                            "aria-label": "Close",
                                          },
                                          on: {
                                            click: _vm.closeactiveservicepopup,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "modal-body" }, [
                                      _vm.selectedpack
                                        ? _c(
                                            "div",
                                            { staticClass: "packages-table" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  "Package Name: " +
                                                    _vm._s(
                                                      _vm.selectedpack
                                                        .Package_id
                                                    )
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "table-responsive",
                                                },
                                                [
                                                  _vm.activeList.length > 0
                                                    ? _c("div", [
                                                        _c(
                                                          "table",
                                                          {
                                                            staticClass:
                                                              "table",
                                                          },
                                                          [
                                                            _c("thead", [
                                                              _c("tr", [
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "Service"
                                                                  ),
                                                                ]),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "Cost"
                                                                  ),
                                                                ]),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "Currency"
                                                                  ),
                                                                ]),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "Redeemed Date"
                                                                  ),
                                                                ]),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "Note"
                                                                  ),
                                                                ]),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "Select"
                                                                  ),
                                                                ]),
                                                              ]),
                                                            ]),
                                                            _c(
                                                              "tbody",
                                                              _vm._l(
                                                                _vm.activeList,
                                                                function (
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "tr",
                                                                    [
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.Service_Name
                                                                          )
                                                                        ),
                                                                      ]),
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          "\n                                    " +
                                                                            _vm._s(
                                                                              _vm.twoDecimal(
                                                                                item.Component_balance
                                                                              )
                                                                            ) +
                                                                            "\n                                  "
                                                                        ),
                                                                      ]),
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.Currency
                                                                          )
                                                                        ),
                                                                      ]),
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          "\n                                    " +
                                                                            _vm._s(
                                                                              item.Active
                                                                                ? new Date(
                                                                                    item.Component_used_date_time
                                                                                  ).toLocaleString(
                                                                                    "en-GB",
                                                                                    {
                                                                                      hour12: true,
                                                                                      dateStyle:
                                                                                        "short",
                                                                                      timeStyle:
                                                                                        "short",
                                                                                    }
                                                                                  )
                                                                                : ""
                                                                            ) +
                                                                            "\n                                  "
                                                                        ),
                                                                      ]),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          class:
                                                                            {
                                                                              "global-disabled":
                                                                                item.Is_used ==
                                                                                "True",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      item.Notes,
                                                                                    expression:
                                                                                      "item.Notes",
                                                                                  },
                                                                                ],
                                                                              attrs:
                                                                                {
                                                                                  type: "text",
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  value:
                                                                                    item.Notes,
                                                                                },
                                                                              on: {
                                                                                input:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    if (
                                                                                      $event
                                                                                        .target
                                                                                        .composing
                                                                                    ) {
                                                                                      return
                                                                                    }
                                                                                    _vm.$set(
                                                                                      item,
                                                                                      "Notes",
                                                                                      $event
                                                                                        .target
                                                                                        .value
                                                                                    )
                                                                                  },
                                                                              },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          class:
                                                                            {
                                                                              "global-disabled":
                                                                                item.Is_used ==
                                                                                "True",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm.selectedservice,
                                                                                    expression:
                                                                                      "selectedservice",
                                                                                  },
                                                                                ],
                                                                              attrs:
                                                                                {
                                                                                  type: "checkbox",
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  value:
                                                                                    item,
                                                                                  checked:
                                                                                    item.Active,
                                                                                  checked:
                                                                                    Array.isArray(
                                                                                      _vm.selectedservice
                                                                                    )
                                                                                      ? _vm._i(
                                                                                          _vm.selectedservice,
                                                                                          item
                                                                                        ) >
                                                                                        -1
                                                                                      : _vm.selectedservice,
                                                                                },
                                                                              on: {
                                                                                change:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    var $$a =
                                                                                        _vm.selectedservice,
                                                                                      $$el =
                                                                                        $event.target,
                                                                                      $$c =
                                                                                        $$el.checked
                                                                                          ? true
                                                                                          : false
                                                                                    if (
                                                                                      Array.isArray(
                                                                                        $$a
                                                                                      )
                                                                                    ) {
                                                                                      var $$v =
                                                                                          item,
                                                                                        $$i =
                                                                                          _vm._i(
                                                                                            $$a,
                                                                                            $$v
                                                                                          )
                                                                                      if (
                                                                                        $$el.checked
                                                                                      ) {
                                                                                        $$i <
                                                                                          0 &&
                                                                                          (_vm.selectedservice =
                                                                                            $$a.concat(
                                                                                              [
                                                                                                $$v,
                                                                                              ]
                                                                                            ))
                                                                                      } else {
                                                                                        $$i >
                                                                                          -1 &&
                                                                                          (_vm.selectedservice =
                                                                                            $$a
                                                                                              .slice(
                                                                                                0,
                                                                                                $$i
                                                                                              )
                                                                                              .concat(
                                                                                                $$a.slice(
                                                                                                  $$i +
                                                                                                    1
                                                                                                )
                                                                                              ))
                                                                                      }
                                                                                    } else {
                                                                                      _vm.selectedservice =
                                                                                        $$c
                                                                                    }
                                                                                  },
                                                                              },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "no-content-added",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "col-md-12 text-center pt-4 d-block",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "No services found."
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                  _vm.markingservice.length > 0
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "primary-btn ripple pull-right",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.redeemservices,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            Redeem\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showloader
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "processing_popup upload full-spinner",
                                                staticStyle: {
                                                  visibility: "visible",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "spinner" },
                                                  [
                                                    _c("div", {
                                                      staticClass: "bounce1",
                                                    }),
                                                    _c("div", {
                                                      staticClass: "bounce2",
                                                    }),
                                                    _c("div", {
                                                      staticClass: "bounce3",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "modal fade packages-popup packages-inner-popup",
                              attrs: {
                                id: "inactiveservices",
                                tabindex: "-1",
                                role: "dialog",
                                "aria-labelledby": "exampleModalCenterTitle",
                                "aria-hidden": "true",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "modal-dialog",
                                  attrs: { role: "document" },
                                },
                                [
                                  _c("div", { staticClass: "modal-content" }, [
                                    _c("div", { staticClass: "modal-header" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "close",
                                          attrs: {
                                            type: "button",
                                            "data-dismiss": "modal",
                                            "aria-label": "Close",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "modal-body" }, [
                                      _c(
                                        "div",
                                        { staticClass: "packages-table" },
                                        [
                                          _vm.selectedpack != null
                                            ? _c("h2", [
                                                _vm._v(
                                                  "\n                          Package Name: " +
                                                    _vm._s(
                                                      _vm.selectedpack
                                                        .Package_id
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "table-responsive" },
                                            [
                                              _vm.inactive_services
                                                ? _c(
                                                    "table",
                                                    { staticClass: "table" },
                                                    [
                                                      _c("thead", [
                                                        _c("tr", [
                                                          _c("th", [
                                                            _vm._v("Service"),
                                                          ]),
                                                          _c("th", [
                                                            _vm._v("Cost"),
                                                          ]),
                                                          _c("th", [
                                                            _vm._v("Currency"),
                                                          ]),
                                                          _c("th", [
                                                            _vm._v(
                                                              "Redeemed Date"
                                                            ),
                                                          ]),
                                                        ]),
                                                      ]),
                                                      _c(
                                                        "tbody",
                                                        _vm._l(
                                                          _vm.inactive_services,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c("tr", [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.Service_Name
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  "\n                                  " +
                                                                    _vm._s(
                                                                      _vm.twoDecimal(
                                                                        item.Component_balance
                                                                      )
                                                                    ) +
                                                                    "\n                                "
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.Currency
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  "\n                                  " +
                                                                    _vm._s(
                                                                      item.Active
                                                                        ? new Date(
                                                                            item.Component_used_date_time
                                                                          ).toLocaleString(
                                                                            "en-GB",
                                                                            {
                                                                              hour12: true,
                                                                              dateStyle:
                                                                                "short",
                                                                              timeStyle:
                                                                                "short",
                                                                            }
                                                                          )
                                                                        : ""
                                                                    ) +
                                                                    "\n                                "
                                                                ),
                                                              ]),
                                                            ])
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isdisplaymsg
            ? _c("Messages", {
                attrs: {
                  datamessage: _vm.sucessmsgtext,
                  isVisible: _vm.isdisplaymsg,
                },
                on: { closemsg: _vm.closeMessage },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("ConfirmBox", {
        ref: "confirmcomp",
        attrs: { showmodal: _vm.showCnfrmPopUp, actionmessage: _vm.actionMsg },
        on: {
          cancelAction: function ($event) {
            _vm.showCnfrmPopUp = false
            _vm.confrmPopUpResponse = false
          },
          confirmAction: function ($event) {
            _vm.showCnfrmPopUp = false
            _vm.confrmPopUpResponse = true
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }